export default __webpack_public_path__ + "static/media/list_main_13_1.f5255793.png";